import { SET_APP_BOOTSTRAP_PHASE } from 'services/app/actions'
import { getAuthIsLoggedIn } from 'services/auth'
import { getUserPortalMetaData } from 'services/portal'
import * as actions from './actions'

/* eslint-disable import/prefer-default-export */
export function watchUserPortalMetadata ({ after }) {
  return after(
    [actions.SET_USER_DATA, SET_APP_BOOTSTRAP_PHASE],
    async ({
      dispatch, state, prevState, action,
    }) => {
      const { auth, app } = state
      const { app: prevApp } = prevState
      const currentBootstrapComplete = app.get('bootstrapComplete')
      const prevBootstrapComplete = prevApp.get('bootstrapComplete')

      if (
        (getAuthIsLoggedIn(auth)
        && action.type === SET_APP_BOOTSTRAP_PHASE
        && currentBootstrapComplete
        && prevBootstrapComplete !== currentBootstrapComplete)
        || (action.type === actions.SET_USER_DATA)
      ) {
        dispatch({
          type: actions.SET_USER_PORTAL_METADATA_PROCESSING,
          payload: true,
        })

        const data = await getUserPortalMetaData({ auth })
        dispatch({
          type: actions.SET_USER_PORTAL_METADATA,
          payload: { data, processing: false },
        })
      }
    },
  )
}
/* eslint-enable import/prefer-default-export */
